// Lộ trình nâng cấp (docs/KE_HOACH_NANG_CAP_DON_VI.md §3.7, §3.12) — kiểu dữ liệu GET /upgrade/progress, /upgrade/approvals.

export type ToType = 'ctv' | 'agency'
export const TO_LABEL: Record<ToType, string> = { ctv: 'CTV', agency: 'Đại lý' }
export const TYPE_LABEL: Record<string, string> = { shop: 'Shop', ctv: 'CTV', agency: 'Đại lý', platform: 'Nhà phân phối' }

export interface ProgressItem {
  key: 'deliveredOrders' | 'goodsValue' | 'activeChildren'
  label: string
  value: number
  target: number
  pct: number
  ok: boolean
}

export interface UpgradeDirection {
  fromType: 'shop' | 'ctv'
  toType: ToType
  target: { minDeliveredOrders: number | null; minGoodsValue: number | null; consecutiveMonths: number; minActiveChildren: number | null; minAccountAgeDays: number | null; note: string | null }
  currentMonth: { month: string; progress: ProgressItem[] }
  closedMonths: { month: string; ok: boolean; progress: ProgressItem[] }[]
  ageOk: boolean
  meetsNow: boolean
  eligibility: { id: string; status: 'eligible' | 'requested'; month: string; expiresAt: string } | null
  plan: { newParent: { id: string | null; name: string; type: string }; approver: 'agency' | 'npp'; leaves: { id: string; name: string; type: string }[] }
}

export interface UpgradeRequest {
  id: string
  status: 'pending' | 'approved' | 'rejected' | 'cancelled'
  createdAt: string
  reviewedAt: string | null
  reviewNote: string | null
  message: string | null
  unit: { id: string; name: string; tenantType: string; status: string } | null
  data: { fromType: string; toType: ToType; newParentId: string | null; approver: 'agency' | 'npp'; leaves: { id: string; name: string; type: string }[] }
  newParent: { id: string | null; name: string }
  metrics: { months?: { month: string; deliveredOrders: number; goodsValue: number; activeChildren: number }[] } | null
  waitingDays: number
}

export interface UpgradeProgress {
  tenantType: string
  upgradeTargets: ToType[]
  directions: UpgradeDirection[]
  pending: UpgradeRequest | null
  history: UpgradeRequest[]
}

export const monthLabel = (m: string) => `${m.slice(5)}/${m.slice(0, 4)}`
